import React, { useEffect, useState } from "react";
import api, { inr } from "../lib/api";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from "recharts";

const label = (m) => {
  const [y, mo] = m.split("-");
  return new Date(Number(y), Number(mo) - 1, 1).toLocaleString("en-IN", { month: "short", year: "2-digit" });
};

export const SalaryTrend = ({ month, refreshKey }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get("/salary/trend", { params: { month, months: 6 } })
      .then((r) => setData(r.data.map((d) => ({ ...d, name: label(d.month) }))))
      .catch(() => setData([]));
  }, [month, refreshKey]);

  return (
    <div data-testid="salary-trend" className="rounded-lg border border-border bg-card p-5 mb-6">
      <div className="flex items-baseline justify-between mb-3">
        <h3 className="font-display text-lg">Salary trend · last 6 months</h3>
        <span className="text-xs text-muted-foreground">Earned vs paid (advances + payments)</span>
      </div>
      {!data ? (
        <div className="h-56 animate-pulse bg-muted rounded-md" />
      ) : (
        <div className="h-56">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ left: 0, right: 8, top: 4, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
              <XAxis dataKey="name" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 11 }} width={64} tickFormatter={(v) => (v >= 100000 ? `${(v / 100000).toFixed(1)}L` : v >= 1000 ? `${Math.round(v / 1000)}k` : v)} />
              <Tooltip formatter={(v) => inr(v)} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar dataKey="earned" name="Earned" fill="hsl(var(--positive))" radius={[4, 4, 0, 0]} />
              <Bar dataKey="paid" name="Paid" fill="hsl(var(--primary))" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};
